export default {
  contacts(state) {
    return state.contacts;
  },
};
